/**
* Service for ads and promotions management.
*
* Responsibilities:
* - Fetch ad slots
* - Manage ad slot configuration
* - Fetch creators ads
* - Fetch a Streamate camera with optional exclusions.
*/
import type {
  IAdManageSlotsResponse,
  IAdSlotsResponse,
  IAdsCreators,
  OnlyFansSource,
  IStreamateCamera,
  IStreamateCameraRequest,
} from "../types";

import type { ApiClient } from "@/common/api/http/types";

export default class AdsService {
  public constructor(private readonly client: ApiClient) {}

  async getAdSlots(): Promise<IAdSlotsResponse> {
    return await this.client.get("v2/adv/slots");
  }

  async getAdManageSlots(): Promise<IAdManageSlotsResponse> {
    return await this.client.get("v2/adv/manage/slots");
  }

  async updateAdManageSlots(names: string[]) {
    return await this.client.post("v2/adv/manage/slots", {
      slots: names
    });
  }

  async getAdsCreators(params: { source: OnlyFansSource; count: number }): Promise<IAdsCreators> {
    return await this.client.get(
      `/v2/adv/creators-traffic?count=${params.count.toString()}&source=${params.source}`
    );
  }

  async getStreamateCamera(req: IStreamateCameraRequest): Promise<IStreamateCamera> {
    const query = new URLSearchParams();

    if (req.exclude.length > 0) {
      query.append("exclude", req.exclude.join(","));
    }

    const res = await this.client.get<Promise<{ camera: IStreamateCamera }>>(
      `v2/cameron/streamate/camera?${query.toString()}`
    );

    return res.camera;
  }
}
